import React from 'react'

const DigitalMultimeter = () => {
  return (
    <div>
         <section class="inner-banner">
        <div class="thm-container">
          <h2> Product Details </h2>
          <div class="breadcumb">
            <a href="/">Yokogawa</a>
            <i class="fa fa-angle-right"></i>
            <span>Handheld Instruments </span>
            <i class="fa fa-angle-right"></i>
            <span>Digital Multimeters</span>
          </div>
        </div>
      </section> 
      <div className='container py-4'>
        <div className='row d-flex' style={{ margin: "80px 0px" }}>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <img src='/img/digitalmultiMeter.png' width={400}></img>
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <h2 style={{ textDecoration: "underline" }}>Digital Multimeters:</h2>
            <p className="mbot25">
              The TY720 Digital Multimeter is a 4.5-digit, 50,000-count dual display RMS
              meter with a 51-segment bar graph display. The TY720 multimeter measures Voltage,
              Current, Resistance, Continuity Check, Diode Test, Frequency, Capacitance, Temperature,
              and Low Power Resistance.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DigitalMultimeter
